var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"other-page"},[_c('HeaderWebOpen',{staticClass:"other-page-header",attrs:{"showImg":false}}),_c('router-view'),_c('FooterWeb')],1),_c('div',{staticClass:"other-page-mob"},[_c('HeaderMob',{staticClass:"other-page-header"}),_c('router-view'),_c('FooterMob')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }